<template>
  <div class="page">
    <!-- landing section  -->
    <section class="pt-5" id="landing">
      <div class="container-fluid pt-5">
          <h1 class="text-center pt-2 heading">Mungai Gikure</h1>
          <div class="text-center">
            <img class="img-fluid" src="../assets/me.png" alt="me">
          </div>
      </div>
      <div class="container-fluid">
          <div class="row">
              <div class="col-sm-4 image"></div>
              <div class="col-sm-8 d-flex align-items-center">
                <p>
                  Web Developement adequately describes my current passion and line of work.
                  I have been developing websites and web applications for some time now, and 
                  it never ceases to amaze me the incredible functionality you can give to your site.
                  Though I am more inclined towards Backend Developement, I find the frontend fascinating as well,
                  owing to its ever changing and evolving technologies. Welcome to my corner of the web!
                </p>
              </div>
          </div>
      </div>
    </section>

    <!-- skills section  -->
    <section class="mt-2 pb-4" id="skills">
      <div class="">
          <h2 class="text-center pt-4 sub-heading">Skills</h2>
          <div class="text-center">
            <img class="img-fluid" src="../assets/skills.png" alt="me">
          </div>
      </div>

      <div class="container-fluid pt-4">

        <div class="row mx-auto">

          <div class="col-sm">
            <ul>
              <li>
                <img class="img-fluid" src="../assets/python.png" alt="me">
                Python
              </li>
              <li>
                <img class="img-fluid" src="../assets/django.png" alt="me">
                Django
              </li>
              <li>
                <img class="img-fluid" src="../assets/rest.png" alt="me">
                Django Rest Framework
              </li>
              <li>
                <img class="img-fluid" src="../assets/js.png" alt="me">
                Javascript
              </li>
            </ul>
          </div>

          <div class="col-sm">
              <ul>
                <li>
                  <img class="img-fluid" src="../assets/vue.png" alt="me">
                  Vue js
                </li>
                <li>
                  <img class="img-fluid" src="../assets/css.png" alt="me">
                  CSS
                </li>
                <li>
                  <img class="img-fluid" src="../assets/html.png" alt="me">
                  HTML
                </li>
              </ul>
          </div>
        </div>
      </div>
    </section>
    
    <!-- services section  -->
    <section class="mt-2 pt-4" id="services">
      <div class="container-fluid some">
          <h2 class="text-center pt-4 sub-heading">Services</h2>
          <div class="text-center">
            <img class="img-fluid" src="../assets/service2.png" alt="me">
          </div>
      </div>

      <div class="container-fluid pt-2 pb-4">
        <div class="row mx-auto">
          <div class="col-sm">
            <ul>
              <li>
                <img class="img-fluid" src="../assets/web.png" alt="me">
                Web Developement
              </li>
              <li>
                <img class="img-fluid" src="../assets/crawler2.png" alt="me">
                Web Scraping and Data Mining
              </li>
              <li>
                <img class="img-fluid" src="../assets/api.png" alt="me">
                API Developement
              </li>
            </ul>
          </div>
          <div class="col-sm">
            <ul>
              <li>
                <img class="img-fluid" src="../assets/bot.png" alt="me">
                Bots
              </li>
              <li>
                <img class="img-fluid" src="../assets/mpesa.png" alt="me">
                Mpesa Integration
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    
    <!-- projects section  -->
    <section class="mt-2 pb-4" id="projects">
      <div class="container-fluid some">
          <h2 class="text-center pt-4 sub-heading">
            Projects
          </h2>
          <div class="text-center">
            <img class="img-fluid" src="../assets/projects.png" alt="me">
          </div>
      </div>

      <div class="container-fluid mt-2">
        <div class="row mx-auto">
          <div class="col-sm">
            <ul>
              <li>
                <a href="#">Cove Dash</a>
              </li>
              <li>
                <a href="#">School Data Relay System</a>
              </li>
              <li>
                <a href="https://xnomradio.com/">Xnom Radio</a>
              </li>
            </ul>
          </div>
          <div class="col-sm">
            <ul>
              <li>
                <a href="http://kahigahomestay.com/">Kahiga HomeStay</a>
              </li>
              <li>
                <a href="#">Upgroww</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    
    <!-- contact section  -->
    <section class="mt-2 pb-4" id="contact">
      <div class="container-fluid some">
          <h2 class="text-center pt-4 mb-2 sub-heading">Leave me a message...</h2>
      </div>

      <div class="container-fluid pt-5 pb-5 d-flex justify-content-center">
        <a class="mx-2" href="mailto:mungaigikure@outlook.com">
          <vue-fontawesome icon="envelope" size="2" color="black"></vue-fontawesome>
          <!-- mungaigikure@outlook.com -->
        </a>
        <a class="mx-2" href="https://t.me/gikure">
          <vue-fontawesome icon="telegram" size="2" color="black"></vue-fontawesome>
          <!-- Telegram -->
        </a>
        <a href="https://twitter.com/gikurejoseph/" class="mx-2">
          <vue-fontawesome icon="twitter" size="2" color="black" ></vue-fontawesome>
        </a>
        <a href="tel:+254707170676" class="mx-2">
          <vue-fontawesome icon="phone" size="2" color="black" ></vue-fontawesome>
        </a>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "Landing"
};
</script>

<style >
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@100&family=Rock+Salt&display=swap');

.page {
  scroll-behavior: smooth;
  scroll-snap-type: y mandatory;
  /* width: 100vw !important; */
  padding: 0;
  margin: 0;
}
section{
  scroll-snap-align: center;
}
.heading{
  font-size: 3em;
  color: white;
  font-family: 'Rock Salt', cursive;
}
.sub-heading{
  font-size: 1.5em;
  font-weight: bolder;
  /* color: white; */
}
#landing{
  background: rgba(55, 71, 190, 0.5); 
}

#services{
  background: rgba(55, 71, 190, 0.5); 
}
#contact{
  background: rgba(55, 71, 190, 0.5); 
}

.image{
  background: url('../assets/black_hand1.png');
  background-repeat: none;
  background-position: center;
  background-size: cover;
  width: 100% !important;
  height: 75vh !important;
  /* min-height: fit-content !important; */
}
#skills ul li{
  list-style: none;
  padding-top: 20px;
}
#services ul li{
  list-style: none;
  padding-top: 20px;
}
#projects ul li{
  list-style: none;
  padding-top: 20px;
}
#projects ul li a{
  color:black;
  text-decoration: none;
}
#projects ul li a:hover{
  color: rgba(92, 107, 221);
  text-decoration: none;
}
.col{
  width: 100% !important;
}
</style>